import React from 'react'
import { Outlet } from 'react-router-dom'

const Tradefair = () => {
  return (
    <div>
        <Outlet />
    </div>
  )
}

export default Tradefair